import {
  backArrowIcon,
  backIcon,
  cartIcon,
  clipIcon,
  iconSetIcon,
  printIcon,
  rupeeIcon,
  searchIcon,
  addIcon,
  deleteIcon,
  pencilIcon,
  assetIcon,
  downloadIcon,
  reportIcon,
  storageIcon,
  uploadIcon,
  offIcon,
  shareIcon,
} from "../../scripts/svg-template";
import { getAllProps } from "../../scripts/utils/utility";

export class IconComponent extends HTMLElement {
  private IconElement: SVGElement;
  private IconPaths: SVGPathElement[];
  private Icons: Map<string, Function> = new Map([
    ["cart", cartIcon],
    ["search", searchIcon],
    ["back", backIcon],
    ["backArrow", backArrowIcon],
    ["rupee", rupeeIcon],
    ["clips", clipIcon],
    ["prints", printIcon],
    ["iconset", iconSetIcon],
    ["add", addIcon],
    ["delete", deleteIcon],
    ["edit", pencilIcon],
    ["asset", assetIcon],
    ["download", downloadIcon],
    ["report", reportIcon],
    ["storage", storageIcon],
    ["upload", uploadIcon],
    ["off", offIcon],
    ["share", shareIcon],
  ]);
  private props: Map<string, string>;
  private propNames = {
    status: "status",
    dataIcon: "data-icon",
    dataWd: "data-wd",
    dataHt: "data-ht",
    dataFill: "data-fill",
    dataStroke: "data-stroke",
    dataRotate: "data-rotate",
  };

  private template = (
    icon: Function,
    dataWd: string,
    dataHt: string,
    dataFill: string,
    dataStroke: string
  ) => `
   ${icon(dataWd, dataHt, dataFill, dataStroke)}
      `;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.props = getAllProps(this);
    this.render();
    this.IconElement = <SVGSVGElement>this.shadowRoot?.querySelector("svg");
    this.IconPaths = Array.from(
      this.shadowRoot?.querySelectorAll("svg path") || []
    ) as SVGPathElement[];
  }

  static get observedAttributes() {
    return ["data-fill", "data-stroke", "data-wd", "data-ht", "data-rotate"];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === this.propNames.dataFill && oldValue !== newValue) {
      this.props.set(this.propNames.dataFill, newValue);
      this.setAttribute(this.propNames.dataFill, newValue);
      this.IconPaths.forEach((item) => item.setAttribute("fill", newValue));
    }

    if (name === this.propNames.dataStroke && oldValue !== newValue) {
      this.props.set(this.propNames.dataStroke, newValue);
      this.setAttribute(this.propNames.dataStroke, newValue);
      this.IconPaths.forEach((item) => item.setAttribute("stroke", newValue));
    }

    if (name === this.propNames.dataWd && oldValue !== newValue) {
      this.props.set(this.propNames.dataWd, newValue);
      this.setAttribute(this.propNames.dataWd, newValue);
      this.IconElement.setAttribute("width", newValue);
    }

    if (name === this.propNames.dataHt && oldValue !== newValue) {
      this.props.set(this.propNames.dataHt, newValue);
      this.setAttribute(this.propNames.dataHt, newValue);
      this.IconElement.setAttribute("height", newValue);
    }
    if (name === this.propNames.dataRotate && oldValue !== newValue) {
      this.props.set(this.propNames.dataRotate, newValue);
      this.setAttribute(this.propNames.dataRotate, newValue);
      this.style.transform = `rotate(${newValue}deg)`;
    }
  }
  render() {
    if (this.shadowRoot) {
      this.style.display = "grid";
      this.style.placeItems = "center";
      const iconName = this.props.get(this.propNames.dataIcon);
      const dataWd = this.props.get(this.propNames.dataWd) || "60";
      const dataHt = this.props.get(this.propNames.dataHt) || "60";
      const dataFill = this.props.get(this.propNames.dataFill) || "black";
      const dataStroke =
        this.props.get(this.propNames.dataStroke) || "transparent";
      const iconFunction =
        iconName && typeof this.Icons.get(iconName) === "function"
          ? this.Icons.get(iconName)
          : null;
      this.shadowRoot.innerHTML = this.template(
        iconFunction || backIcon,
        dataWd,
        dataHt,
        dataFill,
        dataStroke
      ).trim();
    }
  }
}

customElements.define("icon-component", IconComponent);
